var React = require('react');

function NewOrder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M76.668,23.333V20c0-5.521-4.479-10-10.001-10h-40c-5.521,0-10,4.479-10,10v10h5l-5,19.999V90h66.668V49.999L76.668,23.333z   M23.333,20c0-1.841,1.492-3.334,3.333-3.334h30.612c-0.371,1.049-0.611,2.158-0.611,3.334v3.333H23.333V20z M63.333,83.333h-40  V50.819L28.539,30h34.794V20c0-1.841,1.494-3.334,3.334-3.334C68.506,16.666,70,18.159,70,20v3.333l-6.667,26.666V83.333z   M76.668,83.333H70V50.819l3.334-13.333l3.334,13.333V83.333z","key":0}),React.createElement("rect",{"x":"30","y":"70","width":"26.667","height":"6.667","key":1}),React.createElement("rect",{"x":"30","y":"56.666","width":"26.667","height":"6.666","key":2})]);
}

NewOrder.defaultProps = {"version":"1.0","id":"Layer_1","x":"0px","y":"0px","width":"100","height":"100","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = NewOrder;

NewOrder.default = NewOrder;
